import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mrm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtINR(n) {
  const num = Number(n || 0);
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

// ---------- WhatsApp helpers ----------
// Normalise Indian mobile to E.164-lite for wa.me (no plus, digits only).
export function normalizeWaNumber(mobile, defaultCC = "91") {
  const m = String(mobile || "").replace(/[^0-9+]/g, "");
  if (!m) return "";
  if (m.startsWith("+")) return m.slice(1);
  if (m.length === 10) return `${defaultCC}${m}`;
  if (m.length === 12 && m.startsWith("91")) return m;
  return m;
}

export function waLink(mobile, message) {
  const num = normalizeWaNumber(mobile);
  const txt = encodeURIComponent(message || "");
  return num ? `https://wa.me/${num}?text=${txt}` : `https://wa.me/?text=${txt}`;
}

export function openWhatsApp(mobile, message) {
  const url = waLink(mobile, message);
  window.open(url, "_blank", "noopener,noreferrer");
}

